import DeviceService from './device.service';
export default DeviceService;